import ErrorLogo from '../ErrorLogo/ErrorLogo';
import Header from '../Header/Header';
import SubHeader from '../SubHeader/SubHeader';
import './ErrorBox.css';
import { ErrorState } from '../../views/CompleteThreeDSV2/error';

export default function ErrorBox({ error }: { error: ErrorState }): JSX.Element {
  return (
    <div className="error-box">
      <ErrorLogo />
      <Header>{error.title}</Header>
      <SubHeader>{error.message}</SubHeader>
    </div>
  );
}
